export const REQUEST_IS_LOGGED_IN = 'REQUEST_IS_LOGGED_IN';
export const RECEIVE_IS_LOGGED_IN = 'RECEIVE_IS_LOGGED_IN';
export const RECEIVE_IS_LOGGED_IN_TELMEX = 'RECEIVE_IS_LOGGED_IN_TELMEX';
export const RECEIVE_SUBSCRIPTION = 'RECEIVE_SUBSCRIPTION';
export const RECEIVE_LOGIN_DYNAMIC = 'RECEIVE_LOGIN_DYNAMIC';
export const REQUEST_LOGIN = 'REQUEST_LOGIN';
export const REQUEST_FAVORITED_VOD = 'REQUEST_FAVORITED_VOD';
export const REQUEST_FAVORITED_CHANNELS = 'REQUEST_FAVORITED_CHANNELS';
export const UPDATE_FAVORITED_VOD = 'UPDATE_FAVORITED_VOD';
export const UPDATE_FAVORITED_CHANNELS = 'UPDATE_FAVORITED_CHANNELS';
export const DELETE_FAVORITED_VOD = 'DELETE_FAVORITED_VOD';
export const DELETE_FAVORITED_CHANNELS = 'DELETE_FAVORITED_CHANNELS';
export const RECEIVE_LOGIN = 'RECEIVE_LOGIN';

export const REQUEST_AUTHDEVICE = 'REQUEST_AUTHDEVICE';
export const RECEIVE_AUTHDEVICE = 'RECEIVE_AUTHDEVICE';
export const RECEIVE_USER_TOKEN = 'RECEIVE_USER_TOKEN'

export const SET_LASTTOUCH_SEEN = 'SET_LASTTOUCH_SEEN';
export const SET_LASTTOUCH_FAVORITED = 'SET_LASTTOUCH_FAVORITED';
export const SET_LASTTOUCH_PROFILE = 'SET_LASTTOUCH_PROFILE';
export const SET_LASTTOUCH_REMINDER = 'SET_LASTTOUCH_REMINDER';
export const SET_LASTTOUCH_LIVECHANNEL = 'SET_LASTTOUCH_LIVECHANNEL';

export const ACTIVE_MARQUEE = 'ACTIVE_MARQUEE';
export const REQUEST_PUSH_SESSION = 'REQUEST_PUSH_SESSION';
export const RECEIVE_PUSH_SESSION = 'RECEIVE_PUSH_SESSION';

export const SET_ACCEPTED_TERM = 'SET_ACCEPTED_TERM';
export const SET_VALID_EMAIL = 'SET_VALID_EMAIL';

export const CONTINUE_PROCESS_LOGIN_BY_TOKEN = 'CONTINUE_PROCESS_LOGIN_BY_TOKEN';


// WEBPACK FOOTER //
// ./src/actions/user.js